import { useTranslation } from "@sagot/i18n";
import { Button, Icon, Tooltip } from "@sagot/ui";
import { useHistory } from "./history-context";

const H = "engage.workflows.extras.history";

/** Undo and Redo, each naming the edit it would take back or bring back ("Undo: connect Book a tour to Path D"). */
export function HistoryButtons() {
  const { t } = useTranslation();
  const history = useHistory();
  if (!history) return null;
  const undoName = history.undoLabel ? t(`${H}.undoAction`, { action: history.undoLabel }) : t(`${H}.nothingToUndo`);
  const redoName = history.redoLabel ? t(`${H}.redoAction`, { action: history.redoLabel }) : t(`${H}.nothingToRedo`);
  return (
    <div className="flex items-center gap-1" role="group" aria-label={t(`${H}.toolbar`)}>
      <Tooltip content={undoName}>
        <Button type="button" variant="secondary" size="sm" iconOnly aria-label={history.undoLabel ? undoName : t(`${H}.undo`)} aria-disabled={history.undoLabel ? undefined : true} className={history.undoLabel ? undefined : "opacity-50"} data-testid="history-undo" onClick={history.undo}>
          <Icon name="undo-2" />
        </Button>
      </Tooltip>
      <Tooltip content={redoName}>
        <Button type="button" variant="secondary" size="sm" iconOnly aria-label={history.redoLabel ? redoName : t(`${H}.redo`)} aria-disabled={history.redoLabel ? undefined : true} className={history.redoLabel ? undefined : "opacity-50"} data-testid="history-redo" onClick={history.redo}>
          <Icon name="redo-2" />
        </Button>
      </Tooltip>
      <p className="sr-only" role="status" aria-live="polite" data-testid="history-announcer">{history.announcement}</p>
    </div>
  );
}
